module.exports = __webpack_public_path__ + "img/MGH-Yokohama-3.ff0d947e.jpg";